import { useEffect, useState } from "react";
import axios from "axios";

const useInteractiveQuizAnswersFromActiveLicenses = (unique_quiz_id: string, question_id?: string, schoolYear?: string) => {
    const [quizAnswers, setQuizAnswers] = useState<any[]>([]);
    const [availableSchoolYears, setAvailableSchoolYears] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const result = await axios.post(
                    '/api/v1/syllabus/interactive_quiz_answers/filter/',
                    {
                        unique_quiz_id,
                        question_id,
                        school_year: schoolYear
                    },
                    {
                        headers: {
                            'X-CSRFToken': JSON.parse(
                                document.getElementById('csrf_token')!.innerHTML,
                            ),
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (result.data) {
                    setQuizAnswers(result.data.results || []);
                    setAvailableSchoolYears(result.data.available_school_years || []);
                }
            } catch (error) {
                console.error("Error fetching quiz answers:", error);
                setError("answers failed to load");
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [unique_quiz_id, question_id, schoolYear]);

    return {
        quizAnswers,
        availableSchoolYears,
        isLoading,
        error
    };
};

export default useInteractiveQuizAnswersFromActiveLicenses;
